/**
 * Concat every tag found in the items list and then filter it to search only by matches.
 * @param items Items
 * @returns initial tags.
 */
export function getInitialTags<T extends Array<{ tags: string[] | null | undefined }>>(items: T) {
  return items
    .reduce((tags, item) => [...tags, ...(item.tags || [])], [] as string[])
    .filter((tag, i, tags) => {
      return (
        !tags.slice(0, i).some((prevTag) => prevTag === tag) &&
        items.every((item) => item.tags?.some((tagOnItem) => tagOnItem === tag))
      )
    })
}

export function excludeFrom<T>(originals: T[], exclusions: T[]) {
  return originals.filter((original) => exclusions.every((exclusion) => original !== exclusion))
}
